import { styled, Box } from "@mui/material";

export const UploadContainer = styled(Box)(() => ({
  display: "flex",
  "@media(max-width: 768px)": {
    width: "100%",
  },
}));
